import Vue from 'vue'
import App from './App.vue'
import router from './router';
import store from './store';
import { Lazyload } from 'vant';
import axiox from './assets/js/axios'
import commonJs from './assets/js/common'
import publish from './assets/js/pubilshSet'
import commonCss from './assets/css/common.css'
import picUpload from './components/picUpload'
import allScorllPlace from './components/allScorllPlace'
import picUploadVideo from './components/picUploadVideo'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import wx from 'weixin-js-sdk'
let options = {
  fullscreenEl: false,
}
// debugger
Vue.use(preview, options)
Vue.use(preview)
Vue.use(commonCss)
Vue.prototype.$commonJs = commonJs
Vue.prototype.$axiox = axiox
Vue.prototype.$baseUrl = publish.baseUrl
Vue.prototype.$wx = wx
Vue.component('picUpload', picUpload)
Vue.component('picUploadVideo', picUploadVideo)
Vue.component('allScorllPlace', allScorllPlace)
Vue.config.productionTip = false;
Vue.use(Lazyload);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')

;(async (isDebug = false) =>
  isDebug && new (await ((() => import('vconsole'))())).default()
)(window.location.search.includes('debug'))